import React, { useEffect, useState } from 'react'
import SaveTasks from '../../services/general/TaskCrud.api'
import { CButton, CCardTitle, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormInput, CFormLabel, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Cog, LayoutPanelLeft, Plus, Settings2, X } from 'lucide-react'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import { AnimatePresence, motion } from 'framer-motion'
import Select from 'react-select'
import { ColumnDirective, ColumnsDirective, KanbanComponent } from '@syncfusion/ej2-react-kanban'
import { addClass } from '@syncfusion/ej2-base'
import RegisterUser from '../../services/general/register.api'
import { Pending } from '@mui/icons-material'
import Pageloader from '../../components/shared/Pageloader'
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items'
import { useSidebar } from '../../components/SidebarContext'
import UseIsMobile from '../../components/shared/UseIsMobile'
import ProviderCreateTask from './kanban-components/providerCreateTask'
import ProviderUpdateTask from './kanban-components/providerUpdateTask'
import './dashboard.css'

const ProviderBacklog = () => {
  const [todos, setTodos] = useState([])
  const [loading, setLoading] = useState(true)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [updateTaskVisible, setUpdateTaskVisible] = useState(false)
  const [selectedTask, setSelectedTask] = useState(null)
  const [selectedBoardId, setSelectedBoardId] = useState('')
  const [showBoards, setShowBoards] = useState(false)
  const [tasks, setTasks] = useState([])
  const [boardId, setboardId] = useState('')
  const [updateTaskId, setUpdateTaskId] = useState(null)
  const [assignerTask, setAssignerTask] = useState([])
  const isMobile = UseIsMobile()

  const [filters, setFilters] = useState({
    date: '',
    assignee: '',
  })

  const [createBoardState, setCreateBoardState] = useState({
    id: Date.now(),
    title: '',
    description: '',
    tasks: [],
    columns: [],
  })
  const userData = JSON.parse(localStorage.getItem('user'))

  const [users, setUsers] = useState([])

  const GetAllUsers = async () => {
    const response = await RegisterUser('', '', '', '', 'get_all')
    let allUsers = response?.d
    allUsers = allUsers.Users
    if (allUsers.length > 0) {
      setUsers(
        allUsers.map((item) => {
          return {
            name: item.Username,
            label: item.Username,
            value: item?.Username,
            role: 'office',
          }
        }),
      )
    }
  }

  useEffect(() => {
    GetAllUsers()
  }, [])

  const formatDateNew = (dateString) => {
    if (!dateString) return ''
    const parts = dateString.split('-')
    if (parts.length !== 3) return dateString
    const [month, day, year] = parts
    const date = new Date(`${year}-${month}-${day}`)
    return new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date)
  }
  const getTodos = async () => {
    try {
      const response = await SaveTasks('get', null, null)
      const { data, error } = response || {}

      if (error) {
        console.error('Error loading boards:', error)
        return
      }

      setTodos(data || [])
    } catch (err) {
      console.error('Unexpected error:', err)
    } finally {
      setLoading(false)
    }
  }
  const getTask = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'))
      const today = new Date().toISOString().split('T')[0]
      const { data, error } = await supabase
        .from('tasks')
        //    .select('title,assignee,status,dueDate, boardId , dueDate').eq('assignee', userData?.Username).eq('dueDate', today)

        .select('*')
        .eq('assignee', userData?.Username)

      if (error) {
        console.error('Supabase error:', error)
        return
      }
      // let { data: tasks, error } = await supabase  .from('tasks')  .select("*")  // Filters  .eq('column', 'Equal to')  .gt('column', 'Greater than')  .lt('column', 'Less than')  .gte('column', 'Greater than or equal to')  .lte('column', 'Less than or equal to')  .like('column', '%CaseSensitive%')  .ilike('column', '%CaseInsensitive%')  .is('column', null)  .in('column', ['Array', 'Values'])  .neq('column', 'Not equal to')

      setTasks(data || [])
    } catch (err) {
      console.error('Unexpected error:', err)
    } finally {
      setLoading(false)
    }
  }

  const getAssignerTask = async () => {
    setLoading(true)
    try {
      const userData = JSON.parse(localStorage.getItem('user'))
      const today = new Date().toISOString().split('T')[0]
      const response = await SaveTasks('get', null, null)
      const { data, error } = response || {}

      if (error) {
        console.error('Supabase error:', error)
        return
      }
      // let { data: tasks, error } = await supabase  .from('tasks')  .select("*")  // Filters  .eq('column', 'Equal to')  .gt('column', 'Greater than')  .lt('column', 'Less than')  .gte('column', 'Greater than or equal to')  .lte('column', 'Less than or equal to')  .like('column', '%CaseSensitive%')  .ilike('column', '%CaseInsensitive%')  .is('column', null)  .in('column', ['Array', 'Values'])  .neq('column', 'Not equal to')

      setAssignerTask(data || [])
    } catch (err) {
      console.error('Unexpected error:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAssignerTask()
    getTodos()
    getTask()
  }, [])

  const handleSaveBoard = async () => {
    const boardPayload = {
      title: createBoardState.title,
      description: createBoardState.description,
      columns: createBoardState.columns,
    }

    const response = await SaveBoard({ mode: 'INSERT', boardData: boardPayload })
    const { data, error } = response || {}

    if (error) {
      console.error('Error creating board:', error)
      return
    }

    getTodos()
    getTask()
    setEditModalVisible(false)
    setCreateBoardState({
      id: Date.now(),
      title: '',
      description: '',
      tasks: [],
      columns: [],
    })
    toast.success('Board Added successfully', toastConfig)
  }
  const filteredTasks = () => {
    let result = [...tasks]

    // Date filter
    if (filters.date) {
      const selectedDate = new Date(filters.date)
      selectedDate.setHours(23, 59, 59, 999)

      result = result.filter((task) => {
        if (!task.dueDate) return false
        return new Date(task.dueDate) <= selectedDate
      })
    }

    // Assignee filter
    if (filters.assignee) {
      result = result.filter((task) => task.assignee?.toLowerCase() === filters.assignee.toLowerCase())
    }

    return result
  }

  //   useEffect(() => {
  //     const createBoard = async () => {
  //       const boardPayload = {
  //         title: "My First Board",
  //         description: "Board created on first load",
  //         columns: [
  //           { id: "todo", name: "Todo", order: 1 },
  //           { id: "in_progress", name: "In Progress", order: 2 },
  //           { id: "done", name: "Done", order: 3 }
  //         ]
  //       };

  //       const { data, error } = await supabase
  //         .from("board")
  //         .insert([boardPayload])
  //         .select()
  //         .single();

  //       if (error) {
  //         console.error("Error creating board:", error);
  //         return;
  //       }

  //     };

  //     createBoard();
  //   }, []);

  //   {todos.length === 0 ? (
  //     <p>No records found</p>
  //   ) : (
  //     <ul>
  //       {todos.map((todo) => (
  //         <li key={todo.id}>
  //           {JSON.stringify(todo)}
  //         </li>
  //       ))}
  //     </ul>
  //   )}

  const { closeSidebar, openSidebar } = useSidebar()

  useEffect(() => {
    if (isMobile) {
      closeSidebar()
    } else {
      openSidebar()
    }
  }, [isMobile])

  const cardStyle = {
    background: 'var(--ui-dashboard-bg)',
    border: '0',
    borderRadius: '10px',
    padding: isMobile ? '12px' : '16px',
    marginBottom: '20px',
  }

  const tableHeadStyle = {
    background: 'var(--ui-dashboard-surface-2)',
    color: 'var(--ui-text-primary)',
    borderBottom: '1px solid var(--ui-dashboard-border)',
  }

  const tdStyle = {
    color: 'var(--ui-text-secondary)',
    borderColor: 'var(--ui-dashboard-border)',
    verticalAlign: 'middle',
  }

  const hoverRowStyle = {
    cursor: 'pointer',
  }

  if (loading)
    return (
      <div>
        <Pageloader style={{ backgroundColor: 'var(--ui-dashboard-bg)' }} isLoading={loading} />
      </div>
    )

  return (
    <>
      <div
        className="task-management-page position-relative patient-theme-page patient-theme-shell dashboard-dark-theme d-flex flex-column gap-4"
        style={{
          minHeight: '100vh',
          padding: isMobile ? '12px' : '24px',
        }}
      >
        <div className="task-management-header d-flex justify-content-between gap-2">
          {/* <CButton color="primary"
                    className=''
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: "max-content"
                    }}
                    onClick={() => setVisible(true)}>Add New Task</CButton> */}

          <span className="d-flex align-items-center gap-2">
            <CButton className="task-management-icon-button" size="sm" onClick={() => setShowBoards((p) => !p)}>
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </CButton>
            <h5
              className="task-management-title m-0"
              style={{
                color: 'white',
                fontSize: isMobile ? '14px' : '18px',
              }}
            >
              Dashboard
            </h5>
          </span>

          {/* <CButton
                        color="primary"

                        className=""
                        style={{

                            fontSize: isMobile ? '14px' : ''
                        }}
                        onClick={() => setEditModalVisible((p) => !p)}
                    >
                        <Plus size={16} className="me-1" />
                        Add Board
                    </CButton> */}
          <CButton
            color="primary"
            className="task-management-add-button"
            style={{
              fontSize: isMobile ? '14px' : '',
            }}
            onClick={() => setEditModalVisible(true)}
          >
            <Plus size={16} className="me-1" />
            Add Task
          </CButton>
        </div>
        <AnimatePresence>
          {showBoards && (
            <>
              <div
                onClick={(e) => {
                  e.stopPropagation()
                  setShowBoards(!showBoards)
                }}
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: '100%',
                  height: '100vh',
                  zIndex: 1000000000,
                  background: '#6b656545',
                  display: showBoards ? 'block' : 'none',
                }}
              ></div>
              <motion.div
                initial={{
                  opacity: 0,
                  x: showBoards ? '-100%' : '0',
                }}
                animate={{
                  opacity: 1,
                  x: showBoards ? '0' : '-100%',
                }}
                className="board-sidebar"
                style={{
                  position: 'absolute',
                  overflow: 'hidden',
                  overflowY: 'auto',
                  bottom: 0,
                  left: 0,
                  translateX: showBoards ? '0' : '-100%',
                  padding: '1rem',
                  zIndex: 1000000000,
                  height: '100vh',
                  width: '300px',
                  background: 'var(--ui-dashboard-surface)',
                }}
              >
                <a
                  href="/home/ProviderBacklog"
                  style={{
                    // element.style {
                    //     padding-bottom: 18px!important;
                    //     padding-top: 10px!important;
                    //     /* border-bottom: 1px solid red; */
                    //     color: #000;
                    // }
                    paddingBottom: '18px!important',
                    color: 'var(--ui-text-primary)',
                    paddingTop: '10px!important',
                  }}
                  className="d-flex pb-1 align-items-center gap-2 p-2 mb-3"
                >
                  <span style={{ lineHeight: 0 }}>
                    <LayoutPanelLeft size={20} strokeWidth={1} style={{ color: 'white' }} />
                  </span>
                  <CCardTitle
                    style={{
                      fontSize: '17px',
                      color: 'white',
                    }}
                    className="p-0 m-0"
                  >
                    Dashboard
                  </CCardTitle>
                </a>
                {todos.map((brd, idx) => {
                  const isActive = localStorage?.getItem('selected-board-id') == brd?.id

                  return (
                    <motion.div key={idx} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-100">
                      <div
                        onClick={() => {
                          setSelectedBoardId(brd.id)
                          setShowBoards(false)
                          localStorage.setItem('selected-board-id', brd.id)
                          localStorage.setItem('selected-boards', JSON.stringify(brd))
                          window.location.href = `/home/providerKanban/${brd.id}`
                        }}
                        className="d-flex align-items-center w-100 px-3 py-2 rounded"
                        style={{
                          cursor: 'pointer',
                          background: isActive
                            ? 'rgba(77, 163, 255, 0.18)' // active
                            : 'transparent',
                          transition: 'background 0.2s ease',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = isActive ? 'rgba(77, 163, 255, 0.22)' : 'rgba(255,255,255,0.06)')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = isActive ? 'rgba(77, 163, 255, 0.18)' : 'transparent')}
                      >
                        <span
                          className="text-truncate"
                          title={brd?.title}
                          style={{
                            maxWidth: '100%',
                            fontSize: '14px',
                            color: isActive ? '#4da3ff' : '#e0e0e0',
                            fontWeight: isActive ? 600 : 400,
                          }}
                        >
                          {brd?.title}
                        </span>
                      </div>
                    </motion.div>
                  )
                })}
              </motion.div>
            </>
          )}
        </AnimatePresence>
        {/* <div className='d-flex align-items-center justify-content-end gap-2'>
                    <div style={{ position: "relative", display: "inline-block" }}>
                        <CFormInput

                            type="date"
                            color="primary"
                            value={filters.date || ""}
                            aria-describedby="exampleFormControlInputHelpInline"
                            onChange={(e) => {
                                setFilters((p) => ({
                                    ...p,
                                    date: e.target.value
                                }));
                            }}
                        />
                        {filters.date && (
                            <button
                                className='d-flex align-items-center justify-content-center'
                                onClick={() => setFilters((p) => ({ ...p, date: "" }))}
                                style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    width: "20px",
                                    height: "20px",
                                    transform: "translateY(-50%)",
                                    background: "black",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "100px",
                                    color: "var(--ui-text-inverse)",
                                }}
                            >
                                <X className='' strokeWidth={3} size={30} />
                            </button>
                        )}
                    </div>

                    <Select
                        className="w-25"
                        isClearable
                        aria-label="Default select example"
                        placeholder="Select Users"
                        options={users.map((usr) => ({
                            label: usr.label,
                            value: usr.name,
                        }))}
                        onChange={(e) => {
                            setFilters({ ...filters, assignee: e ? e : null })
                        }}
                        value={
                            filters.assignee
                                ? { label: filters.assignee, value: filters.assignee }
                                : null
                        }
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '48px',
                                height: '48px',
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                padding: '0 12px',
                                height: '48px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '48px',
                            }),
                            input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                            }),
                        }}
                    />

                    <CButton
                        variant='outline'
                        color='primary'
                        onClick={() => {
                            setFilters({ ...filters, date: "", assignee: "" })
                        }}
                    >Clear</CButton>
                </div> */}
        <div className="task-dashboard-table-card" style={cardStyle}>
          <h5 className="task-dashboard-table-title" style={{ color: 'var(--ui-text-primary)', marginBottom: '12px', fontSize: isMobile ? '16px' : '20px' }}>Assigned Task</h5>

          <div
            style={{
              width: '100%',
              overflowX: 'auto',
              WebkitOverflowScrolling: 'touch',
              height: '400px',
            }}
          >
            <table
              className="table task-dashboard-table"
              style={{
                marginBottom: 0,
                minWidth: '700px', // ⬅️ important
                whiteSpace: 'nowrap',
              }}
            >
              <thead>
                <tr style={{ background: 'var(--ui-dashboard-surface-2)' }}>
                  <th style={tableHeadStyle}>Task</th>
                  <th style={tableHeadStyle}>Assigned To</th>
                  <th style={tableHeadStyle}>Status</th>
                  <th style={tableHeadStyle}>Due Date</th>
                </tr>
              </thead>

              <tbody>
                {filteredTasks().length > 0 ? (
                  filteredTasks().map((task, index) => (
                    <tr key={index} style={{ background: 'transparent' }} onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.05)')} onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}>
                      <td
                        style={{ ...tdStyle, color: '#4da3ff', cursor: 'pointer' }}
                        onClick={() => {
                          localStorage.setItem('selected-board-id', task.boardId)
                          localStorage.setItem('selected-boards', JSON.stringify(task))
                          // window.location.href = `/home/providerKanban/${task.boardId}`
                          setUpdateTaskId(task)
                          setUpdateTaskVisible(true)
                        }}
                      >
                        {task.title}
                      </td>

                      <td style={tdStyle}>{task.assignee || '-'}</td>

                      <td style={tdStyle}>
                        <span
                          style={{
                            padding: '4px 10px',
                            borderRadius: '12px',
                            background: '#2f2f2f',
                            fontSize: '12px',
                          }}
                        >
                          {task.status || '-'}
                        </span>
                      </td>

                      <td style={tdStyle}>{task.dueDate ? formatDateNew(task.dueDate) : '-'}</td>
                    </tr>
                  ))
                ) : (
                  //new Date(task.dueDate).toLocaleDateString('en-US')
                  <tr>
                    <td colSpan={5} className="text-center text-muted py-4">
                      <p style={{ color: 'var(--ui-text-muted)' }}>No Tasks Available</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="task-dashboard-table-card" style={cardStyle}>
          <h5 className="task-dashboard-table-title" style={{ color: 'var(--ui-text-primary)', marginBottom: '12px', fontSize: isMobile ? '16px' : '20px' }}>Created Task</h5>

          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', minHeight: '200px' }}>
            <table
              className="table task-dashboard-table"
              style={{
                marginBottom: 0,
                minWidth: '700px', // ⬅️ important
                whiteSpace: 'nowrap',
              }}
            >
              <thead>
                <tr style={{ background: 'var(--ui-dashboard-surface-2)' }}>
                  <th style={tableHeadStyle}>Task</th>
                  <th style={tableHeadStyle}>Assigned By</th>
                  <th style={tableHeadStyle}>Assigned To</th>
                  <th style={tableHeadStyle}>Status</th>
                  <th style={tableHeadStyle}>Due Date</th>
                </tr>
              </thead>

              <tbody>
                {assignerTask?.length ? (
                  assignerTask.map((task, index) => (
                    <tr key={index} onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.05)')} onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}>
                      <td
                        style={{ ...tdStyle, color: '#4da3ff', cursor: 'pointer' }}
                        onClick={() => {
                          localStorage.setItem('selected-board-id', task.boardId)
                          localStorage.setItem('selected-boards', JSON.stringify(task))
                          // window.location.href = `/home/providerKanban/${task.boardId}`
                          setUpdateTaskId(task)
                          setUpdateTaskVisible(true)
                        }}
                      >
                        {task.title}
                      </td>
                      <td style={tdStyle}> {task?.assigner || '-'} </td>

                      <td style={tdStyle}>{task.assignee || '-'}</td>

                      <td style={tdStyle}>
                        <span
                          style={{
                            padding: '4px 10px',
                            borderRadius: '12px',
                            background: '#2f2f2f',
                            fontSize: '12px',
                          }}
                        >
                          {task.status || '-'}
                        </span>
                      </td>

                      <td style={tdStyle}>{task.dueDate ? formatDateNew(task.dueDate) : '-'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center text-muted py-4">
                      <p style={{ color: 'var(--ui-text-muted)' }}>No Tasks Available</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ProviderCreateTask visible={editModalVisible} setVisible={setEditModalVisible} fetchBoard={todos} isFromproviderBackLog={true} />

      <ProviderUpdateTask visible={updateTaskVisible} setVisible={setUpdateTaskVisible} task={selectedTask} updateTaskId={updateTaskId} />
    </>

    //  <ProviderUpdateTask
    //             visible={updateTaskVisible}
    //             fetchBoard={todos}
    //             updateTaskId={updateTaskId}
    //             setUpdateTaskId={setUpdateTaskId}
    //             setVisible={setUpdateTaskVisible}
    //         />
    //            <ProviderCreateTask
    //         visible={editModalVisible}
    //         setVisible={setEditModalVisible}
    //         fetchBoardToPage={getTodos}
    //         boards={todos}
    //         />

    /* <CModal visible={editModalVisible} onClose={() => setEditModalVisible(false)}>
                <CModalHeader
                    style={{
                        backgroundColor: '#191919',
                        borderBottom: '1px solid gray',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        borderRadius: '10px 10px 0 0',
                    }}>
                    <CModalTitle
                        style={{ color: 'white', width: '100%', textAlign: 'center' }}
                    >Add Board</CModalTitle>
                </CModalHeader>
                <CModalBody
                    style={{
                        backgroundColor: '#191919',
                        color: 'white',
                    }}
                >
                    <div className="d-flex flex-column gap-2">
                        <span className="">
                            <CFormLabel>Title</CFormLabel>
                            <CFormInput
                                style={{
                                    border: '0',
                                    background: '#8080800d',
                                }}
                                placeholder="Title"
                                name="Title"
                                value={createBoardState.title}
                                onChange={(e) => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        title: e.target.value,
                                    }))
                                }}
                            />
                        </span>
                        <span className="">
                            <CFormLabel>Description</CFormLabel>
                            <CFormTextarea
                                aria-rowcount={10}
                                style={{
                                    height: '150px',
                                    border: '0',
                                    background: '#8080800d',
                                }}
                                placeholder="Description"
                                name="Summary"
                                onChange={(e) => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        description: e.target.value,
                                    }))
                                }}
                            />
                        </span>
                        <div className="d-flex justify-between-end w-full w-100">
                            <CButton variant="outline" color="primary"
                                onClick={() => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        columns: [
                                            ...p.columns,
                                            { headerText: 'To Do', keyField: Date.now(), order: p.columns.length + 1, isCollapse: false },
                                            //...createBoardState.columns,
                                        ],
                                    }))
                                }}
                            >Add Columns</CButton>
                        </div>
                        {createBoardState.columns.length > 0 && (
                            <div className="d-flex flex-column gap-1">
                                <CFormLabel>Columns</CFormLabel>
                                {createBoardState.columns.map((item, idx) => {
                                    return (
                                        <div key={idx} className="d-flex align-items-center gap-2">
                                            <CFormInput
                                                style={{ background: '#8080800d', color: 'white' }}
                                                placeholder={`Add Column ${idx + 1}`}
                                                name={`columns[${idx}].name`}
                                                value={item.headerText}
                                                onChange={(e) => {
                                                    setCreateBoardState((p) => ({
                                                        ...p,
                                                        columns: p.columns.map((i, j) => {
                                                            if (j === idx) {
                                                                return { ...i, headerText: e.target.value, }
                                                            }
                                                            return i
                                                        }),
                                                    }))
                                                }}
                                            />
                                            <CButton
                                                variant="outline"
                                                onClick={() => {
                                                    setCreateBoardState((p) => ({
                                                        ...p,
                                                        columns: p.columns.filter((_, i) => i !== idx),
                                                    }))
                                                }}
                                                className=""
                                                color="danger"
                                            >
                                                Delete
                                            </CButton>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </CModalBody>
                <CModalFooter
                    style={{
                        backgroundColor: '#191919',
                        borderTop: '1px solid gray',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '10px',
                        borderRadius: '0 0 10px 10px',
                    }}
                    className="p-4">
                    <CButton variant="outline" color="secondary" onClick={() => {
                        setEditModalVisible(false), setCreateBoardState({
                            id: Date.now(),
                            title: '',
                            description: '',
                            tasks: [],
                            columns: []
                        })
                    }}>Close</CButton>
                    <CButton color="primary" onClick={() => handleSaveBoard()}>Save changes</CButton>
                </CModalFooter>
            </CModal> */
  )
}

export default ProviderBacklog
